import React from "react";
import { LegalLayout, LegalSection, LegalRow } from "../components/LegalLayout";

const Impressum = () => {
  return (
    <LegalLayout title="Impressum">
      <p className="text-base md:text-lg text-white/75 leading-relaxed">
        Angaben gemäß § 5 DDG (Digitale-Dienste-Gesetz) und § 18 MStV.
      </p>

      <LegalSection title="Diensteanbieter">
        <LegalRow label="Name / Inhaber">Osman Arslan</LegalRow>
        <LegalRow label="Firma / Geschäftsbezeichnung">YOUR CUT</LegalRow>
        <LegalRow label="Rechtsform">Einzelunternehmen</LegalRow>
        <LegalRow label="Anschrift">
          Hammer Steindamm 62, 20535 Hamburg, Deutschland
        </LegalRow>
      </LegalSection>

      <LegalSection title="Kontakt">
        <LegalRow label="Telefon">
          <a
            href="tel:+491637036972"
            className="hover:text-[#E63946] transition-colors"
          >
            +49 163 7036972
          </a>
        </LegalRow>
        <LegalRow label="E-Mail">
          <a
            href="mailto:hallo@yourcut-hamm.de"
            className="hover:text-[#E63946] transition-colors break-all"
          >
            hallo@yourcut-hamm.de
          </a>
        </LegalRow>
      </LegalSection>

      <LegalSection title="Umsatzsteuer / Steuernummer">
        <p className="text-white/80">
          Eine Umsatzsteuer-Identifikationsnummer ist derzeit nicht angegeben.
        </p>
      </LegalSection>

      <LegalSection title="Berufsrechtliche Angaben">
        <LegalRow label="Berufsbezeichnung">
          Friseur (verliehen in der Bundesrepublik Deutschland)
        </LegalRow>
        <LegalRow label="Berufsrechtliche Regelungen">
          Handwerksordnung (HwO) – einsehbar unter{" "}
          <a
            href="https://www.gesetze-im-internet.de/hwo/"
            target="_blank"
            rel="noreferrer"
            className="text-[#E63946] hover:underline break-words"
          >
            www.gesetze-im-internet.de/hwo/
          </a>
        </LegalRow>
      </LegalSection>

      <LegalSection title="Inhaltlich verantwortlich (§ 18 Abs. 2 MStV)">
        <p className="text-white/80">
          Osman Arslan, Hammer Steindamm 62, 20535 Hamburg, Deutschland
        </p>
      </LegalSection>

      <LegalSection title="EU-Streitschlichtung">
        <p>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung
          bereit:{" "}
          <a
            href="https://ec.europa.eu/consumers/odr/"
            target="_blank"
            rel="noreferrer"
            className="text-[#E63946] hover:underline break-words"
          >
            https://ec.europa.eu/consumers/odr/
          </a>
        </p>
      </LegalSection>

      <LegalSection title="Verbraucherstreitbeilegung / Universalschlichtungsstelle">
        <p>
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
          vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </LegalSection>

      <LegalSection title="Haftung für Inhalte">
        <p>
          Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach
          den allgemeinen Gesetzen verantwortlich. Wir sind jedoch nicht
          verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
          überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
          Tätigkeit hinweisen.
        </p>
      </LegalSection>

      <LegalSection title="Haftung für Links">
        <p>
          Unser Angebot enthält Links zu externen Websites Dritter, auf deren
          Inhalte wir keinen Einfluss haben. Für diese fremden Inhalte übernehmen
          wir keine Gewähr. Für die Inhalte der verlinkten Seiten ist stets der
          jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
        </p>
      </LegalSection>

      <LegalSection title="Urheberrecht">
        <p>
          Die durch den Seitenbetreiber erstellten Inhalte und Werke auf dieser
          Website unterliegen dem deutschen Urheberrecht. Beiträge Dritter sind
          als solche gekennzeichnet.
        </p>
      </LegalSection>
    </LegalLayout>
  );
};

export default Impressum;
